
import { Component, Vue } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule";
import { RulesEnum, rules } from "@/lib/rules/rules.map";

@Component({})
export default class RulesMixin extends Vue {
  readonly RulesEnum = RulesEnum;
  readonly rules = rules;

  get requiredRule() {
    return [requiredRule()];
  }

  /**
   * hides error text
   */
  get requiredRuleSilent() {
    return [requiredRule(" ")];
  }
}
